import React from "react";
import checkboxguidelines1 from "assets/images/png/checkboxguidelines1.png";
import checkboxguidelines2 from "assets/images/png/checkboxguidelines2.png";

const ComponentPrimaryDatas = [
	{
		id: 1,
		title: "Do",
		titleClassname: "active",
		image: checkboxguidelines1,
		description: "Do let text wrap beneath the checkbox so the control and label are top aligned. ",
	},
	{
		id: 2,
		title: "Don’t",
		titleClassname: "inactive",
		image: checkboxguidelines2,
		description: "Do not vertically center wrapped text with the checkbox. ",
	},
];

const GuidelineCardCheckbox = () => {
	return (
		<div className="guideline-card d-flex justify-content-between">
			{ComponentPrimaryDatas.map((data) => (
				<div key={data.id} className="guideline-wrapper">
					<h6 className={`guideline-badge plt-body-compact-md dis-mb-8 ${data.titleClassname}`}>{data.title}</h6>
					<div className="guideline-detail-wrapper d-flex align-items-center justify-content-center">
						<div className="guideline-img">
							<img src={data.image} alt="userimage" />
						</div>
					</div>
					<p className="guideline-desc plt-body-md dis-mt-12">{data.description}</p>
				</div>
			))}
		</div>
	);
};

export default GuidelineCardCheckbox;
